import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Modal, Upload} from "antd";
import {t} from "i18next";
import {
    generateUUID2, getFileName, getFileNameWithoutExt,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme, getLocalFilePath,
    imgPathPerfix, isBase64,
    isDarkMode,
    isImage
} from "@/utils";
import Dragger from "antd/es/upload/Dragger";
import {ipcInvoke} from "@/common/ipc";
import {ARRAY_DEFAULT_PROJECT_ITEM_THUMB, ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG} from "@/Const";
import global from "@/global";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";

let mCallback:any;
const DialogChooseProjectLinkImage = forwardRef((props:{onCloseCallback:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [imagePath,setImagePath] = useState(null);

    const onShowDialog = (szImagePath,callback:any)=>{
        setIsShowDialog(true);
        setImagePath(szImagePath);
        mCallback = callback;
    }

    const onPaste = (event:any)=>{
        if (!isShowDialog)return;
        // event.preventDefault();
        // 可以通过 event.clipboardData 访问剪切板数据
        var clipboardData = event.clipboardData || window.clipboardData;
        if (clipboardData.files && clipboardData.files.length > 0){
            if (clipboardData.files[0].path){
                handleCrop(clipboardData.files[0].path)
                //实际路径的图片
                // ipcInvoke('copy-file', {filePath: clipboardData.files[0].path}).then(res => {
                //     if (mCallback){
                //         mCallback("localfile://"+res);
                //     }
                // });
            }else{
                navigator.clipboard.read().then(async (clipboardItems) => {
                    for (const clipboardItem of clipboardItems) {
                        for (const type of clipboardItem.types) {
                            if (type.startsWith('image/')) {
                                const blob = await clipboardItem.getType(type);
                                const reader = new FileReader();

                                reader.onload = function(event) {
                                    const szBase64 = event.target.result;
                                    const szFileName = generateUUID2()+'.png';
                                    // 处理图片
                                    var item = {
                                        fileName:szFileName,
                                        data:szBase64.split(',')[1]
                                    }
                                    // ipcInvoke('write-base64-files',JSON.stringify([item])).then(res=>{
                                    //     if (mCallback){
                                    //         mCallback("localfile://"+szFileName);
                                    //     }
                                    // });
                                    handleCrop(szBase64);
                                };

                                reader.readAsDataURL(blob); // 转换图片为DataURL格式
                            }
                        }
                    }
                });
            }
        }
        // setIsShowDialog(false);
    }
    useEffect(()=>{
        document.body.addEventListener('paste',onPaste);
        return ()=>{
            document.body.removeEventListener('paste',onPaste);
        }
    })

    useEffect(() => {
        global.g_showDialogs['dialogChooseImage'] = true;
        return ()=>{
            global.g_showDialogs['dialogChooseImage'] = false;
        }
    }, []);

    useEffect(() => {
        global.g_showDialogs['dialogChooseImage'] = isShowDialog;
    }, [isShowDialog]);

    const uploadProps:{ beforeUpload: (file) => string } = {
        beforeUpload:(file)=>{
            if (isImage(file.path)){

                handleCrop(file.path);
                // if (mCallback){
                //     //复制到文件
                //     ipcInvoke('copy-file', {filePath: file.path}).then(res => {
                //         mCallback("localfile://"+res);
                //     });
                //
                //     setIsShowDialog(false);
                // }
            }

            return Upload.LIST_IGNORE
        }
    }

    /**
     * 处理剪切
     * @param path
     */
    const handleCrop = (path:any)=>{
        window.showDialogImageCrop(isBase64(path)?path:getLocalFilePath(path,true),(szImagePath:any)=>{
            setIsShowDialog(false);
            //删除之前的缩略图--如果有的话.
            if (imagePath){
                //修复高度
                mCallback({action:'reduceHeight'})
                ipcInvoke('delete-files-file',{fileName:getFileName(imagePath)});
            }
            mCallback({action:'ok',imagePath:szImagePath});
        });
    }


    return(
        <Modal centered={true} width='620px' bodyStyle={{}} open={isShowDialog} closeIcon={<IconClose/>} onCancel={()=> {
            setIsShowDialog(false)
        }} footer={''}>
            <div style={{display: 'flex', flexDirection: 'column'}} className={'font-size-12'}>
                <span className='dialog-title'>{t("Change thumbnail")}</span>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <div style={{
                    margin: '6px 0px 0px 0px',
                    border: '1px dashed var(--border-dashed-color)',
                    borderRadius: '8px',
                    height: '260px'
                }}>
                    <Dragger {...uploadProps} accept={".jpg,.png,.bmp,.jpeg,.svg"}
                             style={{outline: 'none', background: 'transparent', border: 'none', width: '100%'}}>

                        <div className={'flex-center'}>
                           <span className="ant-upload-text">
                            <img style={{width: '26px', height: '26px'}}
                                 src={getImagePathWithTheme("thumb_upload_info")}/>
                        </span>
                            <span className={'font-family-medium ml-6'}
                                  style={{color: 'var(--drag-file-desc-color)'}}>{t("PasteImageOrClick")}</span>
                        </div>
                    </Dragger>
                </div>

                {
                    imagePath &&
                    <div className={'flex-center mt-16 cursor-pointer hovered-red-background'}
                         style={{borderRadius: '8px', border: '1px solid var(--border-red-color)', height: '40px'}} onClick={()=>{
                             //移除...
                        mCallback({action:'remove'});
                        //删除图片.
                        ipcInvoke('delete-files-file',{fileName:getFileName(imagePath)});
                        setImagePath(null);
                        //关闭
                        props.onCloseCallback();
                    }}>
                        <img className={'img-16'} src={getImagePathWithTheme('remove_red.svg')}/>
                        <span className={'ml-8'} style={{color: 'var(--border-red-color)'}}>{t("RemoveSelectedThumbnail")}</span>
                    </div>
                }

            </div>
        </Modal>
    )
})

export default DialogChooseProjectLinkImage;